import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createStore } from "redux";
import allReducers from "./redux/reducer/allReducers.reducer";
import { Provider } from "react-redux";
import { useState } from "react";
import { LoadingContext } from "./context/loadingContext";
import loader from "./assets/Image/loader.gif";
import { ToastContainer } from "react-toastify";
const store = createStore(
  allReducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

const Main = () => {
  const [loading, setLoading] = useState(false);
  return (
    <>
      {window.scrollTo(0, 0)}
      {loading === true ? (
        <div className="loadingGif">
          <img src={loader} />
        </div>
      ) : (
        ""
      )}
      <Provider store={store}>
        {/* <React.StrictMode> */}
        <LoadingContext.Provider value={{ setLoading }}>
          <App />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
          />
        </LoadingContext.Provider>
        {/* </React.StrictMode> */}
      </Provider>
    </>
  );
};
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Main />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
